module.exports = __webpack_public_path__ + "img/bouayadapp.aba0873c.jpg";